export enum EventObjectTypeEnum {
  TruckingCompany = 0,
  Policy = 1,
  Agency = 2,
}
